/*
 * Copyright (C) 2019 Toshiba Corporation
 * SPDX-License-Identifier: Apache-2.0
 */

export type EShapeLineBasePointsHitTesterToThreshold = (
	size: number,
	scale: number,
	offset: number
) => number;
